import { render, staticRenderFns } from "./BuscaPedido.vue?vue&type=template&id=26cd5983&scoped=true"
import script from "./BuscaPedido.vue?vue&type=script&lang=js"
export * from "./BuscaPedido.vue?vue&type=script&lang=js"
import style0 from "./BuscaPedido.vue?vue&type=style&index=0&id=26cd5983&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cd5983",
  null
  
)

export default component.exports